import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Http from "../../Http";
import { Blog_Api } from "../../Helper";
import { motion } from "framer-motion";

const HomeBlog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await Http.post(Blog_Api);
        const latestBlogs = response.blogs
          .sort((a, b) => new Date(b.content_date) - new Date(a.content_date))
          .slice(0, 3);
        setBlogs(latestBlogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <section className="py-10 bg-gradient-to-br from-white to-gray-50 text-gray-900">
      <div className="max-w-7xl mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-4xl font-extrabold text-center mb-12"
        >
          📰 Latest Blogs
        </motion.h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {blogs.map((blog, index) => (
            <motion.div
              key={blog.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-300 transform hover:-translate-y-1"
            >
              <img
                src={blog.content_image}
                alt={blog.content_title}
                className="w-full h-52 object-cover rounded-t-xl"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold mb-2 hover:text-blue-600 transition">
                  {blog.content_title}
                </h3>
                <p className="text-sm text-gray-500 mb-4">
                  {new Date(blog.content_date).toLocaleDateString()}
                </p>
                <Link
                  to={`/blog/${blog.content_url}`}
                  className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition duration-300"
                >
                  Read More →
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <Link
            to="/blog"
            className="inline-block bg-blue-600 text-white py-3 px-8 rounded-full shadow-md hover:bg-blue-700 hover:shadow-lg transition duration-300 text-lg font-semibold"
          >
            View All Blogs
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default HomeBlog;
